import { call, put, select, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import { axiosGet, axiosPost, axiosPut, axiosDelete } from "../../utils/common/axios";
import { getAllContactAsResponse } from "../actions";


export function* getAllContactAsEffectSaga(action) {
  try {
    // contact-as was replaced by get-in-touch, which keeps the form fields inside a JSON column
    const companyId = yield select((state) => state?.login?.user?.companyId);
    const { data } = yield call(() =>
      axiosGet(`get-in-touch/company/${companyId}`)
    );
    const rows = (Array.isArray(data) ? data : []).map((item) => ({
      ...(item?.getInTouch || {}),
      id: item?.id,
      companyId: item?.companyId,
    }));
    yield put(getAllContactAsResponse(rows));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllContactAsResponse([]));
  }
}


export function* contactAsWatcherSaga() {
  yield takeLatest(types.GET_ALL_CONTACT_AS, getAllContactAsEffectSaga);
}
